/*
 * Author: Dw
 * File Created: Tuesday, 24-07-23 10:12 pm
 * Last Modified: Thursday, 25-04-10 05:00 pm, by Dw
 */

import { useEffect } from 'react';

import { load } from '@fingerprintjs/fingerprintjs';

import { cookies } from '@web/utils';

import { logger } from '@/utils';

const useFingerprintjs = () => {
  useEffect(() => {
    init();
  }, []);

  const init = () => {
    const fpPromise = load();

    fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        const visitorId = result.visitorId;

        // todo need add device-id
        cookies.set('fingerprint', visitorId, {
          path: '/',
          maxAge: 31536000,
          secure: true,
          sameSite: 'strict',
        });
      })
      .catch((e) => {
        logger.error('Init fingerprint failed', e);
      });
  };
};

export default useFingerprintjs;
